/**
 * Cart
 * @module components/Cart
 */

import { useContext } from 'react';
import { Items } from './Cart.styles';
import { LocalizationContext } from 'context/localization.context';
import { ViewContext } from 'context/view.context';
import { useSelector } from 'react-redux';
import { selectCartObject } from 'store/modules/cart';

import useWindowSize from 'hooks/useWindowSize';
import clsx from 'clsx';
import Icon from '../Icon';

interface Props {
	/** Link to CartPage */
	link: string;

	/** Link target */
	target?: string;

	cartDisabled: boolean;
}

const Cart = ({ link, target, cartDisabled }: Props) => {
	const { t } = useContext<any>(LocalizationContext);
	const { items } = useSelector(selectCartObject);

	const isMobile = useWindowSize(1150);

	const { view } = useContext<any>(ViewContext);

	const isMobileView = (isMobile || view === 'mobile') && view !== 'desktop';

	return (
		<a
			target={target || '_self'}
			href={link || '/'}
			className={clsx(
				'relative inline-flex items-center font-semibold text-p py-1.75 px-4 ml-auto whitespace-no-wrap md:border h-auto border-black rounded-full',
				cartDisabled ? 'opacity-50' : 'hover:underline'
			)}
		>
			<span className="flex justify-center items-center">
				<Icon icon="cart" size={1} className="md:mr-2" />
				<span className="hidden md:inline-block">
					{t('shared/header/cart')}
				</span>
				<span className="sr-only">
					{t(
						cartDisabled ? 'shared/header/carthidden' : 'shared/header/showcart'
					)}
				</span>
			</span>
			{!cartDisabled && (
				<span>
					<span className="sr-only">{t('shared/header/cartitems')}</span>
					<Items>{items}</Items>
				</span>
			)}
		</a>
	);
};

export default Cart;
